<template>
  <div class="oneTimeReplenishment">
    <p class="Tips">
      {{ $t('subscription_details.replenishment.additional.oneTime.confirmText', 'Would you like to order additional one-time replenishment?') }}
    </p>
    <app-button
      type="submit"
      @click.prevent="$bus.$emit('open-modal', 'replenishmentOneTime')"
      @click.native="trackConversion({ name: 'interaction', description: 'order_additional_onetime_replenishment' })"
      :is-loading="orderOneTimeReplenishmentTask.isActive"
      data-name="oneTimeReplenishment-submitButton"
    >
      {{ $t('subscription_details.replenishment.additional.oneTime.button', 'Order additional one-time replenishment') }} ›
    </app-button>

    <app-modal name="replenishmentOneTime" width="500" >
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.replenishment.additional.oneTime.confirmationModal.title', 'order additional one-time replenishment') }}
        </h3>

        <div class="modal-content">
          <p>
            {{ $t('subscription_details.replenishment.additional.oneTime.confirmationModal.text', 'Are you sure you want to order additional one-time replenishment?') }}
          </p>

          <div class="modal-button-warpper">
            <app-button
              type="submit"
              @click.prevent="orderOneTimeReplenishmentTask.run()"
            >
              {{ $t('subscription_details.replenishment.additional.oneTime.confirmationModal.button.ok', 'Ok') }}
            </app-button>

            <app-button @click="$bus.$emit('close-modal', 'replenishmentOneTime')">
              {{ $t('subscription_details.replenishment.additional.oneTime.confirmationModal.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'replenishment-one-time-order',

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionRatePlanId: {
        type: String,
        required: true
      }
    },

    tasks (t) {
      return {
        orderOneTimeReplenishmentTask: t(async function () {
          this.$bus.$emit('close-modal', 'replenishmentOneTime')
          await Vue.api.subscription.orderOneTimeReplenishment(this.subscriptionNumber, this.subscriptionRatePlanId)
          this.$notify({
            type: 'success',
            title: this.$t('subscription_details.replenishment.additional.oneTime.orderProcessed.popUpMessage', 'Order additional one-time replenishment is being processed and you can see it on the accordion of one-tiem orders after processing')
          })
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    }
  }
</script>
